import React, { useContext, useState, useEffect } from 'react';
import ScopeContext from '../../contexts/ScopeContext';
import AuthContext from '../../contexts/AuthContext';
import CreateGroupModal from './CreateGroupModal';
import JoinGroupModal from './JoinGroupModal';
import ModalOverlay from '../ModalOverlay';
import { FaUsers } from 'react-icons/fa';

const getDismissedKey = (userId) => `groupPromoBannerDismissed:${userId}`;

const GroupPromoBanner = () => {
    const { groups } = useContext(ScopeContext);
    const { user } = useContext(AuthContext);
    const [isDismissed, setIsDismissed] = useState(() => {
        if (!user?.id) return false;
        return localStorage.getItem(getDismissedKey(user.id)) === 'true';
    });
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showJoinModal, setShowJoinModal] = useState(false);

    // Listen for logout to reset modal states
    useEffect(() => {
        const handleLogout = () => {
            setShowCreateModal(false);
            setShowJoinModal(false);
        };
        window.addEventListener('auth:logout', handleLogout);
        return () => window.removeEventListener('auth:logout', handleLogout);
    }, []);

    const handleDismiss = () => {
        if (user?.id) {
            localStorage.setItem(getDismissedKey(user.id), 'true');
        }
        setIsDismissed(true);
    };

    // Don't show if no user, user has groups, or has dismissed
    if (!user?.id || groups.length > 0 || isDismissed) {
        return null;
    }

    return (
        <>
            <div className="group-promo-banner">
                <div className="group-promo-header">
                    <span className="group-promo-title">
                        <FaUsers size={12} /> Compete with friends
                    </span>
                    <button
                        className="group-promo-dismiss"
                        onClick={handleDismiss}
                        aria-label="Dismiss banner"
                    >
                        ✕
                    </button>
                </div>
                <div className="group-promo-description">
                    Create or join a group to compare scores
                </div>
                <div className="group-promo-actions">
                    <button
                        className="group-promo-btn"
                        onClick={() => setShowCreateModal(true)}
                    >
                        Create group
                    </button>
                    <button
                        className="group-promo-btn"
                        onClick={() => setShowJoinModal(true)}
                    >
                        Join group
                    </button>
                </div>
            </div>

            {showCreateModal && (
                <>
                    <ModalOverlay onClick={() => setShowCreateModal(false)} />
                    <CreateGroupModal
                        onClose={() => setShowCreateModal(false)}
                        onSuccess={() => setShowCreateModal(false)}
                    />
                </>
            )}
            {showJoinModal && (
                <>
                    <ModalOverlay onClick={() => setShowJoinModal(false)} />
                    <JoinGroupModal onClose={() => setShowJoinModal(false)} />
                </>
            )}
        </>
    );
};

export default GroupPromoBanner;
